import clsx from 'clsx';
import { ChangeEvent, InputHTMLAttributes, memo, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    id: string;
    checked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}>

export type CheckboxButtonProps = Props & InputHTMLAttributes<HTMLInputElement>

export const CheckboxButton = memo((
    {
        onChange,
        disabled,
        value,
        id,
        checked,
        name,
        required,
        children,
        ...rest
    }: CheckboxButtonProps,
) => (
    <div className="vss-checkbox-button">
        <input
            {...rest}
            type="checkbox"
            className="vss-checkbox-button__input"
            onChange={onChange}
            id={id}
            disabled={disabled}
            value={value}
            name={name}
            required={required}
            checked={checked}
        />

        <label
            htmlFor={id}
            className={clsx({
                'vss-checkbox-button__label': true,
                'vss-checkbox-button__label--disabled': disabled,
            })}
        >
            <span className={clsx({
                'vss-checkbox-button__appearance': true,
                'vss-checkbox-button__appearance--disabled': disabled,
            })}
            />

            <p className={clsx({
                'vss-checkbox-button__label-text': true,
                'vss-checkbox-button__label-text--disabled': disabled,
            })}
            >
                {children}
            </p>
        </label>
    </div>
));
